module.exports = __webpack_public_path__ + "static/uni_florida-cceedd87f51b1ea11afbdc8aeb253207.png";